
import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
    setup()
    {
        const i18n = useI18n();
        const isOpen = ref(false);

        function changeLocale(newLocale: string): void
        {
            i18n.locale.value = newLocale;
            isOpen.value = false;
        }

        return {
            i18n,
            isOpen,
            changeLocale,
        };
    },
})
